<template>
	<div class="template-list-card mx-5 mt-2">
		<app-table
			sticky-header
			class="template-table"
			name="templates"
			:columns="columns"
			:column-widths="{ 1: '23%', 2: '30%', 3: '15%', 4: '32%' }"
			:current-page="currentPage"
			:rows="rows"
			:last-page="lastPage"
			:search-value="searchValue"
			@on-page="$emit('on-page', $event)"
			@on-search-event="$emit('on-search', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable template-name-cell"
					:title="props.row.name"
				>
					{{ props.row.name }}
				</td>
				<td class="template-description-cell" :title="props.row.description">
					{{ props.row.description }}
				</td>
				<td class="template-date-cell">
					{{ displayDate(props.row.createdAt) }}
				</td>
				<td class="template-actions-cell">
					<div class="template-actions">
					<app-tooltip-button
						color="primary"
						icon="create"
						text="Editar Nombre"
						@click-icon="editName(props.row)"
					/>
					<app-tooltip-button
						color="green"
						icon="visibility"
						text="Detalle"
						@click-icon="detail(props.row.id)"
					/>
					<app-tooltip-button
						color="primary"
						icon="add_circle_outline"
						text="Nueva Compañia"
						@click-icon="newTemplate(props.row)"
					/>
					<app-tooltip-button
						color="infor"
						icon="developer_board"
						text="Distribución de roles"
						@click-icon="rolesDistribution(props.row)"
					/>
					<app-tooltip-button
						color="info"
						icon="cached"
						text="Distrib. Recursos"
						@click-icon="resource(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="highlight_off"
						text="Eliminar"
					/>
					<app-tooltip-button
						color="primary"
						text="Configurar Procesos"
						icon="build"
						@click-icon="configurationProcess(props.row)"
					/>
					</div>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import helper from '@/shared/helper';

const { formatDate, getLocalData, setLocalData } = helper;

function displayDate(value) {
	if (!value) return '—';
	const normalizedDate = typeof value === 'string' ? value.replace(' ', 'T') : value;
	return formatDate(normalizedDate, 'DD/MM/YYYY HH:mm');
}

function resource({ codeTemplate }) {
	this.goTo('page-distribution-of-resources', { params: { idDistribution: codeTemplate } });
}

function created() {
	this.idProject = this.projectId || getLocalData('project-id');
}

function detail(id) {
	this.goTo('page-template-detail', { params: { id, projectId: this.idProject } });
}

function newTemplate({ id, codeTemplate }) {
	setLocalData('code-template', codeTemplate);
	this.goTo('page-new-company', {
		params: { codeProject: this.codeProject },
		query: {
			templateId: id,
			codeTemplate,
			returnTo: 'page-template',
		},
	});
}

function rolesDistribution({ id, codeTemplate }) {
	this.goTo('page-resources-assignment', {
		params: { idTemplate: id },
		query: { codeTemplate },
	});
}

function editName({ codeTemplate, id }) {
	this.goTo('page-template-edit', { params: { id, codeTemplate, projectId: this.idProject } });
}

function configurationProcess({ codeTemplate, id }) {
	this.goTo('page-configuration-process', { params: { codeTemplate, id } });
}

function data() {
	return {
		idProject: 0,
	};
}

export default {
	name: 'template-list',
	components: {
		appTooltipButton,
	},
	created,
	data,
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		searchValue: {
			type: String,
			default: '',
		},
		codeProject: {
			type: String,
		},
		projectId: {
			type: [Number, String],
		},
	},
	methods: {
		configurationProcess,
		detail,
		displayDate,
		newTemplate,
		rolesDistribution,
		resource,
		editName,
	},
};
</script>

<style lang="scss" scoped>
.template-list-card {
	background: white;
	border: 1px solid #dfe6ee;
	border-radius: 8px;
	box-shadow: 0 4px 14px rgba(31, 56, 82, .08);
	overflow: hidden;
}

.template-list-toolbar {
	align-items: center;
	background: #f7f9fc;
	border-bottom: 1px solid #e4eaf0;
	display: flex;
	justify-content: space-between;
	min-height: 66px;
	padding: 10px 18px;

	h3 {
		color: #34495e;
		margin: 0 0 3px;
	}

	span {
		color: #71808e;
		font-size: 12px;
	}
}

.template-count {
	background: #e6f2fd;
	border-radius: 14px;
	color: #1A4338 !important;
	font-weight: 600;
	padding: 5px 11px;
	white-space: nowrap;
}

.template-actions {
	align-items: center;
	display: flex;
	justify-content: center;
	white-space: nowrap;
}

.template-actions-cell {
	min-width: 0;
}

.template-name-cell,
.template-description-cell,
.template-date-cell {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.template-date-cell {
	text-align: center;
}

@media (max-width: 700px) {
	.template-list-card {
		margin-left: 12px !important;
		margin-right: 12px !important;
	}

	.template-list-toolbar {
		align-items: flex-start;
		flex-direction: column;
	}
}
</style>

<style lang="scss">
.template-table .table-list { table-layout: fixed; }
</style>



// WEBPACK FOOTER //
// src/components/template/template-list.vue